import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { DROPDOWN_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.div<{
    variant: 'default' | 'fluid';
    disabled: boolean;
  }>`
    ${DROPDOWN_RESET}

    width: 100%;
    opacity: ${(props) => (props.disabled ? 0.6 : 1)};
    position: relative;
  `,

  /* Above the input */
  TopSection: styled.div`
    padding-bottom: ${SPACING.size8};
    display: flex;
    flex-direction: column;
    gap: ${SPACING.size4};
  `,

  Label: styled.label`
    ${TYPOGRAPHY.labelMediumRegularDense}
    color: ${COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
  `,

  FluidLabel: styled.label<{ $isFloating?: boolean }>`
    ${({ $isFloating }) =>
      $isFloating ? TYPOGRAPHY.labelXtraSmallRegular : TYPOGRAPHY.labelMediumMedium};

    color: ${COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
    transition: all 0.2s ease;
    position: absolute;
    left: 16px;

    /* Always set position and transform, but vary the values based on $isFloating */
    top: ${({ $isFloating }) => ($isFloating ? '6px' : '28px')};
    transform: ${({ $isFloating }) => ($isFloating ? 'translateY(0)' : 'translateY(-50%)')};
  `,

  FluidLabelIcon: styled.div`
    padding-left: ${SPACING.size4};
    display: flex;
    align-items: center;
  `,

  Description: styled.p`
    ${TYPOGRAPHY.overlineMediumRegular}
    color: ${COLORS['cloud-900']};
  `,

  InputContainer: styled.div<{
    $state: 'success' | 'error' | 'idle' | 'disabled';
  }>`
    border-radius: 12px;
    border: 1px solid
      ${(props) => {
        switch (props.$state) {
          case 'success':
            return COLORS['success-900'];
          case 'error':
            return COLORS['danger-500'];
          case 'disabled':
          case 'idle':
            return COLORS['charcoal-alpha-50'];
        }
      }};

    background-color: ${COLORS['white-200']};
    padding-left: ${SPACING.size16};
    padding-right: ${SPACING.size16};
    display: flex;
    align-items: center;

    //  FIXME: Make focus-visible from accessibility perspective look better. Instead of default
    /* &:focus-within {
      outline: 2px solid #0066ff;
      outline-offset: 2px;
    } */
  `,

  Input: styled.input<{
    $isFluid?: boolean;
  }>`
    ${TYPOGRAPHY.labelMediumMedium}
    flex: 1;
    min-width: 0;
    border: 0;
    background: transparent;
    text-overflow: ellipsis;
    color: ${COLORS['charcoal-500']};

    height: ${(props) => (props.$isFluid ? '42px' : '56px')};
    margin-top: ${(props) => (props.$isFluid ? SPACING.size12 : '0')};

    &::placeholder {
      color: ${COLORS['charcoal-300']};
    }

    // FIXME: Make focus-visible from accessibility perspective look better. Instead of default
    &:focus-visible {
      outline: none;
      border: 0;
    }
  `,

  SuffixWrapper: styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: auto;
  `,

  Suffix: styled.p`
    ${TYPOGRAPHY.labelMediumRegular}
    color: ${COLORS['charcoal-300']};
    padding-right: ${SPACING.size16};
    text-align: right;
  `,

  BottomSection: styled.div`
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
    padding-left: ${SPACING.size12};
    margin-top: ${SPACING.size8};
    height: 12px;
  `,

  HelperText: styled.p<{ $validationState: 'success' | 'error' | 'idle' }>`
    ${TYPOGRAPHY.labelXtraSmallRegular}
    color: ${(props) => {
      switch (props.$validationState) {
        case 'success':
          return COLORS['success-900'];
        case 'error':
          return COLORS['danger-500'];
        default:
          return COLORS['pebble-500'];
      }
    }};
  `,
  OptionsContainer: styled.div`
    background-color: ${COLORS['white-200']};
    border: 1px solid;
    border-color: ${COLORS['charcoal-alpha-50']};
    position: absolute;
    width: 100%;
    max-height: 100px;
    overflow-y: auto;
  `,
  Option: styled.div`
    padding: ${SPACING.size8};
    padding-left: ${SPACING.size16};
    cursor: pointer;

    &:hover {
      background-color: ${COLORS['charcoal-alpha-100']};
    }
  `
};
